<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Fees Reports",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Fees Termly Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Termly Report",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Student Name",
          sortable: true,
        },
        {
          key: "class",
          label: "Class",
          sortable: true,
        },
        {
          key: "term",
          label: "Term",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "mode",
          label: "Payment Mode",
          sortable: true,
        },
        {
          key: "date",
          label: "Payment Date",
          sortable: true,
        },
        {
          key: "receipt",
          label: "Receipt No",
          sortable: true,
        },
        {
          key: "paidby",
          label: "Paid By",
          sortable: true,
        },
      ],
      data: {
        class: 0,
        term: 0,
        year: moment(new Date()).format("YYYY"),
      },
      terms: [
        { id: 1, name: "Term 1" },
        { id: 2, name: "Term 2" },
        { id: 3, name: "Term 3" },
      ],
      years: [
        { name: new Date().getFullYear() },
        { name: new Date().getFullYear() - 1 },
        { name: new Date().getFullYear() - 2 },
        { name: new Date().getFullYear() - 3 },
      ],
      assigned: [],
    };
  },
  computed: {
    ...mapGetters("fees", ["TermlyReport", "SaveStatus"]),
    ...mapGetters("classes", ["AllClasses"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.assigned ? this.assigned.length : 1;
    },
  },
  watch: {
    TermlyReport(newValue) {
      if (newValue) {
        this.assign();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.assigned ? this.assigned.length : 1;
  },
  methods: {
    ...mapActions({
      FetchPayments: "fees/fetchTermlyReport",
      FetchClasses: "classes/fetchClasses",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.assigned ? this.assigned.length : 1;
      this.currentPage = 1;
    },
    fetch_payments() {
      this.FetchPayments(this.data);
    },
    assign() {
      this.assigned = this.TermlyReport;
    },
  },
  created() {
    this.FetchClasses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_payments')
        )
      "
    >
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label>Class</label>
                <div class="input-group">
                  <select class="form-control" v-model="data.class">
                    <option value="0">All Classes</option>
                    <option
                      v-for="(t, index) in AllClasses"
                      :key="index"
                      :value="t.id"
                    >
                      {{ t.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label>Term</label>
                <div class="input-group">
                  <select class="form-control" v-model="data.term">
                    <option value="0">Select Term</option>
                    <option
                      v-for="(t, index) in terms"
                      :key="index"
                      :value="t.id"
                    >
                      {{ t.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label>Year</label>
                <div class="input-group">
                  <select class="form-control" v-model="data.year">
                    <option
                      v-for="(y, index) in years"
                      :key="index"
                      :value="y.name"
                    >
                      {{ y.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3 mt-2">
                <br />
                <button class="btn btn-success" @click="fetch_payments()">
                  <i class="fa fa-search"></i> Search
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="assigned ? assigned.payments : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
              <table
                width="100%"
                style="
                  border-top: 1px solid #ccc;
                  border-bottom: 1px solid #ccc;
                "
              >
                <tr>
                  <td width="50%"><h2>TOTAL</h2></td>
                  <td width="50%">
                    <h2>{{ assigned.tot }}/=</h2>
                  </td>
                </tr>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red !important;
}
/* .custom{
    width: 350px;
} */
</style>
